import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { loadAssetOverrides } from '../assets/overridesSource';
import { App } from './App';
import './styles.css';

const root = document.getElementById('studio-root');
if (root) {
  const render = (): void => {
    createRoot(root).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  };
  // Load asset overrides first so the login logo reflects an uploaded
  // replacement (assetOverrides are public-readable). Renders regardless.
  loadAssetOverrides().finally(render);
}
